import { types } from './types';

const INITIAL_STATE = {
  status: null,
  isUserNP: null,
  mustChangePassword: false,
  loadingTaxis: false, // For getTaxisData
  loadingUser: false, // For getUser
  checkingAuth: false, // For checking if user is authorized for private routes
  isLoggingOut: false,
  // For checking if user has already confirmed registration
  checkValidated: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  taxis_data: {
    mainKadCode: null,
  },
  fundingAccount: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
  },
  companyLogo: {
    isLoading: false,
    isError: false,
    error: null,
    data: null,
    uploadResult: null,
  },
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.LOGOUT_USER.START:
      return {
        ...state,
        isLoggingOut: true,
      };
    case types.CHECK_VALIDATED.START:
      return {
        ...state,
        checkValidated: {
          isLoading: true,
          isError: false,
          error: null,
          data: null,
        },
      };
    case types.CHECK_VALIDATED.SUCCESS:
      return {
        ...state,
        checkValidated: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload,
        },
      };
    case types.CHECK_VALIDATED.ERROR:
      return {
        ...state,
        checkValidated: {
          isLoading: false,
          isError: true,
          error: payload,
          data: null,
        },
      };

    case types.GET_FUNDING_ACCOUNT.SUCCESS:
      return {
        ...state,
        fundingAccount: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload,
        },
      };

    case types.GET_FUNDING_ACCOUNT.ERROR:
      return {
        ...state,
        fundingAccount: {
          isLoading: false,
          isError: true,
          error: payload,
          data: null,
        },
      };

    case types.UPDATE_FUNDING_ACCOUNT.SUCCESS:
      return {
        ...state,
        fundingAccount: {
          isLoading: false,
          isError: false,
          error: null,
          data: payload,
        },
      };

    case types.UPDATE_FUNDING_ACCOUNT.ERROR:
      return {
        ...state,
        fundingAccount: {
          isLoading: false,
          isError: true,
          error: payload,
          data: null,
        },
      };

    case types.GET_LOGO.SUCCESS:
      return {
        ...state,
        companyLogo: {
          ...state.companyLogo,
          isLoading: false,
          isError: false,
          data: payload,
        },
      };

    case types.GET_LOGO.ERROR:
      return {
        ...state,
        companyLogo: {
          ...state.companyLogo,
          isLoading: false,
          isError: true,
          error: payload,
          data: null,
        },
      };

    case types.UPLOAD_LOGO.SUCCESS:
      return {
        ...state,
        companyLogo: {
          ...state.companyLogo,
          isLoading: false,
          isError: false,
          uploadResult: payload,
        },
      };

    case types.UPLOAD_LOGO.ERROR:
      return {
        ...state,
        companyLogo: {
          ...state.companyLogo,
          isLoading: false,
          isError: true,
          error: payload,
        },
      };

    //DELETE company-logo

    // case types.DELETE_LOGO.START:
    //   return {
    //     ...state,
    //     companyLogo: {
    //       ...state.companyLogo,
    //       isLoading: true,
    //       isError: false,
    //       error: null,
    //     },
    //   };

    // case types.DELETE_LOGO.SUCCESS:
    //   return {
    //     ...state,
    //     companyLogo: {
    //       isLoading: false,
    //       isError: false,
    //       error: null,
    //       data: null,
    //       uploadResult: null,
    //     },
    //   };

    // case types.DELETE_LOGO.ERROR:
    //   return {
    //     ...state,
    //     companyLogo: {
    //       ...state.companyLogo,
    //       isLoading: false,
    //       isError: true,
    //       error: payload,
    //     },
    //   };

    case types.GET_USER_DATA.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.GET_USER_DATA.ERROR:
      return {
        ...state,
        status: 400,
      };
    case types.GET_USER.START:
      return {
        ...state,
        loadingUser: true,
      };
    case types.GET_USER.ERROR:
      return {
        ...state,
        loadingUser: false,
      };
    case types.GET_USER.SUCCESS:
      return {
        ...state,
        loadingUser: false,
        ...payload,
      };
    case types.CHECK_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.CHECK_USER_LOGGED.START:
      return {
        ...state,
        checkingAuth: true,
      };
    case types.CHECK_USER_LOGGED.SUCCESS:
      return {
        ...state,
        checkingAuth: false,
        ...payload,
      };
    case types.CHECK_USER_LOGGED.ERROR:
      return {
        ...state,
        checkingAuth: false,
        ...payload,
      };
    case types.UPDATE_USER.SUCCESS:
      return {
        ...state,
        ...payload,
      };
    case types.UPDATE_USER_NP:
      return {
        ...state,
        isUserNP: payload,
        loading: false,
      };
    case types.LOGIN_ERROR:
      return {
        ...state,
        hasError: true,
        message: payload,
        loading: false,
      };
    case types.SET_FORM_INFO:
      return { ...state, hasInfo: true, message: payload };
    case types.GET_TAXIS_DATA.START:
      return {
        ...state,
        loadingTaxis: true,
      };
    case types.GET_TAXIS_DATA.SUCCESS:
      return {
        ...state,
        loadingTaxis: false,
        isUserNP: payload.mainKadCode ? true : false,
        taxis_data: { ...payload, afmTrimmed: payload?.afm?.trim() },
      };
    case types.GET_TAXIS_DATA.ERROR:
      return {
        ...state,
        loadingTaxis: false,
      };
    case types.CLEAR_USER:
    case types.LOGOUT_USER.SUCCESS:
    case types.LOGOUT_USER.ERROR:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default reducer;
